import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  message: null,

  userDetailsLoading: false,
  userDetailsFailed: false,
  userDetailsError: false,
  userDetailsMessage: null,
  userDetails: {},

  getUserDetailsLoading: false,
  getUserDetailsFailed: false,
  getUserDetailsError: false,
  getUserDetailsMessage: null,
  userDetailsList: [],

  createNewUserLoading: false,
  createNewUserFailed: false,
  createNewUserError: false,
  createNewUserMessage: null,

  updateUserLoading: false,
  updateUserFailed: false,
  updateUserError: false,
  updateUserMessage: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.USER_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null
      };
    case actionTypes.USER_BY_ID_LOADING:
      return {
        ...state,
        userDetailsLoading: true,
        userDetailsFailed: false,
        userDetailsError: false,
        userDetailsMessage: null,
        userDetails: {}
      };
    case actionTypes.FETCH_USERS_SUCCESSY:
      return {
        ...state,
        users: action.payload,
        usersList: action.payload.users,
        loading: false,
        failed: false,
        error: false,
        message: null
      };
    case actionTypes.FETCH_USERS_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message
      };
    case actionTypes.FETCH_USERS_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null
      };
    case actionTypes.FETCH_USER_BY_ID_REJECT:
      return {
        ...state,
        userDetailsloading: false,
        userDetailsFailed: false,
        userDetails: {},
        userDetailsError: true,
        userDetailsMessage: null
      };
    case actionTypes.FETCH_USER_BY_ID_SUCCESSY:
      return {
        ...state,
        userDetails: { ...action.payload },
        userDetailsLoading: false,
        userDetailsFailed: false,
        userDetailsError: false,
        userDetailsMessage: null
      };
    case actionTypes.FETCH_USER_BY_ID_FAILED:
      return {
        ...state,
        userDetailsLoading: false,
        userDetailsFailed: true,
        userDetailsError: false,
        userDetails: {},
        userDetailsMessage: message
      };

    case actionTypes.FETCH_ALL_USER_DETAILS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getUserDetailsLoading: false,
        getUserDetailsFailed: true,
        getUserDetailsError: false,
        getUserDetailsMessage: message,
        userDetailsList: []
      };
    }
    case actionTypes.FETCH_ALL_USER_DETAILS_SUCCESS: {
      // console.log('rrrrrrr', [...action.payload]);
      // const data = {
      //   userData: [...action.payload][0],
      //   transactionList: [...action.payload][1],
      //   reserveList: [...action.payload][2],
      //   ticketList: [...action.payload][3],
      //   invoiceList: [...action.payload][4]
      // };
      const { message } = action.payload;
      return {
        ...state,
        getUserDetailsLoading: false,
        getUserDetailsFailed: false,
        getUserDetailsError: false,
        getUserDetailsMessage: '',
        userDetailsList: [...action.payload]
        // userDetailsList: data
      };
    }
    case actionTypes.FETCH_ALL_USER_DETAILS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getUserDetailsLoading: false,
        getUserDetailsFailed: false,
        getUserDetailsError: true,
        getUserDetailsMessage: '',
        userDetailsList: []
      };
    }
    case actionTypes.FETCH_ALL_USER_DETAILS_LOADING: {
      const { message } = action.payload;
      return {
        ...state,
        getUserDetailsLoading: true,
        getUserDetailsFailed: false,
        getUserDetailsError: false,
        getUserDetailsMessage: '',
        userDetailsList: []
      };
    }

    case actionTypes.CREATE_NEW_USER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createNewUserLoading: false,
        createNewUserFailed: true,
        createNewUserError: false,
        createNewUserMessage: message
      };
    }
    case actionTypes.CREATE_NEW_USER_SUCCESS: {
      return {
        ...state,
        createNewUserLoading: false,
        createNewUserFailed: false,
        createNewUserError: false,
        createNewUserMessage: null
      };
    }
    case actionTypes.CREATE_NEW_USER_REJECT: {
      return {
        ...state,
        createNewUserLoading: false,
        createNewUserFailed: false,
        createNewUserError: true,
        createNewUserMessage: ''
      };
    }
    case actionTypes.CREATE_NEW_USER_LOADING: {
      return {
        ...state,
        createNewUserLoading: true,
        createNewUserFailed: false,
        createNewUserError: false,
        createNewUserMessage: ''
      };
    }

    case actionTypes.UPDATE_USER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateUserLoading: false,
        updateUserFailed: true,
        updateUserError: false,
        updateUserMessage: message
      };
    }
    case actionTypes.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        updateUserLoading: false,
        updateUserFailed: false,
        updateUserError: false,
        updateUserMessage: null
      };
    }
    case actionTypes.UPDATE_USER_REJECT: {
      return {
        ...state,
        updateUserLoading: false,
        updateUserFailed: false,
        updateUserError: true,
        updateUserMessage: ''
      };
    }
    case actionTypes.UPDATE_USER_LOADING: {
      return {
        ...state,
        updateUserLoading: true,
        updateUserFailed: false,
        updateUserError: false,
        updateUserMessage: ''
      };
    }

    default:
      return state;
  }
};
